// ============================================================
// Domain event producers (Tasks 6 + 7).
//
// Thin glue called from the view handlers when a consequential thing happens.
// Each producer fans out to the audit trail (durable record) and, where
// relevant, to notifications (e.g. tell contractors an NCR was raised).
// All calls are best-effort / non-blocking — they never gate the UI action.
// ============================================================
import { logAudit } from "./audit";
import { notifyMembers } from "./notifications";

/** An inspection item result was submitted (pass / fail / clear). Logged for
 *  the audit trail — every submit, per the brief's Task 6. */
export function onInspectionSubmit(location: string, itemIdx: number, status: string): void {
  void logAudit("inspection.submit", "inspection", `${location}#${itemIdx}`, { status });
}

/** A bulk inspection action (whole table / inverter set / clear) was applied. */
export function onBulkInspection(location: string, action: string): void {
  void logAudit("inspection.bulk", "inspection", location, { action });
}

/** A non-conformance was raised against an inspection item. */
export function onNcrRaised(ref: string, location: string): void {
  void logAudit("ncr.raise", "ncr", ref, { location });
  void notifyMembers(
    ["contractor"],
    "ncr_raised",
    ref,
    `${ref} raised at ${location} — close-out required`,
    "/punch",
  );
}

/** An RFI was created. */
export function onRfiCreated(id: string, title: string): void {
  void logAudit("rfi.create", "rfi", id, { title });
  void notifyMembers(["contractor"], "rfi_update", id, `New RFI ${id}: ${title}`, "/rfi");
}

/** A document was approved in the register. */
export function onDocApproved(id: string, name: string): void {
  void logAudit("doc.approve", "doc", id, { name });
}

/** Contractor submitted close-out evidence — notify the QC managers. */
export function onCloseoutSubmitted(ref: string): void {
  void logAudit("ncr.closeout", "ncr", ref, {});
  void notifyMembers(["qcmanager"], "closeout", ref, `Close-out evidence submitted for ${ref}`, "/punch");
}
